import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MiscService {

  constructor(private http: HttpClient) { }

  private endpoints = {
    sendEmail: '/dashboard/sendemail'
  };

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  sendEmail(templateName) {
    const endPoint = this.endpoints.sendEmail;
    const params = {
      'mail_template': templateName,
      'mail_template_params': {}
    };
    return this.http.post<any>(endPoint, params, this.httpOptions).pipe(
      map(this.extractData)
    );
  }
}
